import React, { useState, useEffect } from 'react';
import { Card, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import ProfileUserImg from '../assets/images/profile-user-img.svg';
import EmailVerify from '../assets/images/email-verify.svg';
import EmailConfirm from '../assets/images/email-confirm.svg';
import { Link, useNavigate } from 'react-router-dom';
import Delete from '../assets/images/delete.svg';
import { UPDATE_USER, SAVE_CLIENT_PROFILE } from '../api/constants';
import Swal from 'sweetalert2';
import useDetailedSuburbs from "../hooks/useDetailedSuburbs";
import Select from "react-select";

export default function ProfileComp({ profile }) {
    const navigate = useNavigate()
    const user = JSON.parse(localStorage.getItem("user"))
    const role = user.role;
    const [showEditName, setShowEditName] = useState(false);
    const [showEditScreenName, setShowEditScreenName] = useState(false);
    const [showEditEmail, setShowEditEmail] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showVerifyEmail, setShowVerifyEmail] = useState(false);
    const [showCheckEmail, setShowCheckEmail] = useState(false);
    const [showEdiProfileImg, setShowEdiProfileImg] = useState(false);
    const [showDeactivate, setShowDeactivate] = useState(false);
    const [showEditDetails, setShowEditDetails] = useState(false);
    const [showSuburbModal, setShowSuburbModal] = useState(false);
    const [updated, setUpdated] = useState(false);
    const { suburbs } = useDetailedSuburbs();
    console.log("suburbs", suburbs)

    //profile photo
    const [profile_photo, setProfilePhoto] = useState('')
    const [username, setUsername] = useState(profile.username)
    const [email, setEmail] = useState(profile.email)
    const [first_name, setFirstName] = useState(profile.first_name)
    const [last_name, setLastName] = useState(profile.last_name)
    const [password, setPassword] = useState('')
    const [old_password, setOldPassword] = useState('')

    //Fields
    const formatDate = (isoString) => {
        if (!isoString) return '';
        return isoString.split('T')[0]; // "2001-01-04"
    };
    const [id_or_passport_number, setIDNumber] = useState('')
    const [id_document, setIDFile] = useState('')
    const [physical_address, setPhysicalAddress] = useState(profile.physical_address)
    const [phone_number, setPhoneNumber] = useState(profile.phone_number)

    const [date_of_birth, setDOB] = useState(
        profile.date_of_birth ? formatDate(profile.date_of_birth) : ''
    );
    const [gender, setGender] = useState(profile.gender ? profile.gender : '')
    const [suburb, setSuburb] = useState([])
    const [error, setError] = useState('');

    const options = suburbs.map(s => ({
        value: s.id,
        label: s.suburb_name
    }));

    const handleChange = (selectedOptions) => {
        // For clients, only allow single selection
        setSuburb(selectedOptions ? [selectedOptions.value] : []);
    };

    const selectedValues = suburb.length > 0 ? options.find(o => o.value === suburb[0]) : null;

    useEffect(() => {
        if (profile) {
            setFirstName(profile.first_name || '');
            setLastName(profile.last_name || '');
            setUsername(profile.username || '');
            setEmail(profile.email || '');
            setIDNumber(profile.id_or_passport_number || '');
            setPhysicalAddress(profile.physical_address || '');
            setPhoneNumber(profile.phone_number || '');
            setDOB(profile.date_of_birth ? formatDate(profile.date_of_birth) : '');
            setGender(profile.gender || '');
            // For clients, find the suburb id from the name
            const suburbOption = options.find(o => o.label === profile.suburb);
            setSuburb(suburbOption ? [suburbOption.value] : []);
        }
    }, [profile]);

    const token = localStorage.getItem("token");

    const updateProfileDetails = (e) => {
        e.preventDefault();
        const formData = new FormData();
        var url = SAVE_CLIENT_PROFILE;

        // text fields
        formData.append('id_or_passport_number', id_or_passport_number);
        formData.append('physical_address', physical_address);
        formData.append('phone_number', phone_number);
        formData.append('date_of_birth', date_of_birth);
        formData.append('gender', gender);
        formData.append('suburb_id', suburb[0] || '');
        if(profile_photo != ""){    
        formData.append('profile_photo', profile_photo);
        }
        console.log(suburb)

        // files (IMPORTANT: append FILE, not name)
        if (id_document instanceof File) {
            formData.append('id_document', id_document);
        }

        setError("");
        // Call your API to create account
        fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Profile updated successfully',
                        text: data.message
                    }).then(() => {
                        setShowEditDetails(false);
                        if (profile_photo != "") {
                            console.log(data)
                            const user = JSON.parse(localStorage.getItem("user")) || {}
                            user.profile_photo = data.data.profile_photo;
                            localStorage.setItem("user", JSON.stringify(user));
                        }
                        window.location.reload()
                    });
                } else {
                    setError(data.errors);
                }
            })
            .catch((error) => {
                console.error("Error updating profile:", error);
                setError("Error updating profile");
            });
    };

    const updateAccountDetails = (e) => {
        e.preventDefault();

        setError("");
        // Call your API to create account
        fetch(`${UPDATE_USER}/${profile.user_id}`, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                username: username,
                email: email,
                first_name: first_name,
                last_name: last_name,
                password: password,
                old_password: old_password
            })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Profile updated successfully',
                        text: data.message
                    }).then(() => {
                        setShowEditDetails(false);
                        if (profile_photo != "") {
                            const user = JSON.parse(localStorage.getItem("user")) || {}
                            user.profile_photo = data.data.profile_photo;
                            localStorage.setItem("user", JSON.stringify(user));
                        } else if (first_name != data.data.first_name) {
                            const user = JSON.parse(localStorage.getItem("user")) || {}
                            user.first_name = data.data.first_name;
                            localStorage.setItem("user", JSON.stringify(user));
                        } else if (last_name != data.data.last_name) {
                            const user = JSON.parse(localStorage.getItem("user")) || {}
                            user.last_name = data.data.last_name;
                            localStorage.setItem("user", JSON.stringify(user));
                        } else if (password != "") {
                            localStorage.removeItem("user")
                            localStorage.removeItem("token")
                            navigate("/sign-in")
                        }
                        window.location.reload()
                    });
                } else {
                    setError(data.errors);
                }
            })
            .catch((error) => {
                console.error("Error updating profile:", error);
                setError("Error updating profile");
            });
    };

    return (<>
        <div className='tab-header'>
            <h2>Profile</h2>
            <p>Personalize your account and update your sign in preferences.</p>
        </div>
        <Card className="tab-box">
            <div className="tab-box-wrap">
                <h5>Personal Info</h5>
                <div className="avatar-box">
<Image
  src={profile.profile_photo || ProfileUserImg}
  roundedCircle
  width={80}
  height={80}
  style={{ objectFit: 'cover' }}
  onError={(e) => {
    e.target.src = ProfileUserImg;
  }}
/>                    <Button className='custom-bttn style-3' onClick={() => setShowEdiProfileImg(true)}>Choose Image</Button>
                </div>
                <div className="info-box">
                    <div className='info-box-text'>
                        <h6>Name</h6>
                        <p>{profile.first_name} {profile.last_name}</p>
                    </div>
                    <Button className='custom-bttn style-2' onClick={() => setShowEditName(true)}>Edit</Button>
                </div>
                <div className="info-box">
                    <div className='info-box-text'>
                        <h6>Screen Name / Username</h6>
                        <p>{profile.username}</p>
                    </div>
                    <Button className='custom-bttn style-2' onClick={() => setShowEditScreenName(true)}>Edit</Button>
                </div>
            </div>
            <div className="tab-box-wrap">
                <h5>Sign in & Security</h5>
                <div className="info-box">
                    <div className='info-box-text'>
                        <div className='d-flex flex-column'>
                            <h6>Email</h6>
                            <span>The email address associated with your account.</span>
                        </div>
                        <p>{profile.email}</p>
                    </div>
                    <div className="d-flex gap-2 profile-bttn-group">
                        <Button className='custom-bttn style-2' onClick={() => setShowEditEmail(true)}>Edit Email Address</Button>
                    </div>
                </div>
                <div className="info-box">
                    <div className='info-box-text'>
                        <div className='d-flex flex-column'>
                            <h6>Password</h6>
                            <span>Set a unique password to protect your account.</span>
                        </div>
                    </div>
                    <Button className='custom-bttn style-2' onClick={() => setShowChangePassword(true)}>Change Password</Button>
                </div>
            </div>

            <div className="tab-box-wrap">
                <h5>Other Details</h5>
                <div className="info-box">
                    <div className='d-flex flex-column'>
                        <h6>Phone Number</h6>
                        <p className='small text-muted'>{profile.phone_number}</p>
                    </div>

                    <div className='d-flex flex-column'>
                        <h6>Date of Birth</h6>
                        <p className='small text-muted'>{new Date(profile.date_of_birth).toLocaleDateString()}</p>
                    </div>
                    <div className='d-flex flex-column'>
                        <h6>Gender</h6>
                        <p className='small text-muted'>{profile.gender}</p>
                    </div>
                </div>
                <div className="info-box">
                    <div className='d-flex flex-column'>
                        <h6>ID / Passport</h6>
                        <p className='small text-muted'>{id_or_passport_number}</p>
                    </div>

                    <div className='d-flex flex-column'>
                        <h6>Physical Address</h6>
                        <p className='small text-muted'>{profile.physical_address}</p>
                    </div>

                    <div className='d-flex flex-column'>
                        <h6>Suburb</h6>
                        <p className="small text-muted">{profile.suburb}</p>
                    </div>
                </div>

                <div className="info-box">
                    <div className='info-box-text'>
                        <div className='d-flex flex-column'>

                        </div>
                    </div>
                    <Button className='custom-bttn style-2' onClick={() => setShowEditDetails(true)}>Edit Details</Button>
                </div>
            </div>

            <div className="tab-box-wrap">
                <h5>Manage account</h5>
                <div className="info-box mb-0">
                    <div className='info-box-text'>
                        <div className='d-flex flex-column'>
                            <h6>Deactivate my account</h6>
                            <span>This will shut down your account, but retain your information. You won't be able to sign in again until your account is reactivated.</span>
                        </div>
                    </div>
                    <Button className='custom-bttn primary-line' onClick={() => setShowDeactivate(true)}>Deactivate Account</Button>
                </div>
            </div>
        </Card>

        <Modal className='modal-profile' show={showEditName} onHide={() => setShowEditName(false)} centered>
            <Modal.Header closeButton><Modal.Title>Edit Name</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form onSubmit={updateAccountDetails}>
                    <Row>
                        <Col md="6">
                            <Form.Group className="mb-4"><Form.Label>First Name <span>*</span></Form.Label><Form.Control type="text" placeholder="Ex. John" name='first_name' value={first_name} onChange={(e) => setFirstName(e.target.value)} /></Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-4"><Form.Label>Last Name <span>*</span></Form.Label><Form.Control type="text" placeholder="Ex. Doe" name='last_name' value={last_name} onChange={(e) => setLastName(e.target.value)} /></Form.Group>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-center gap-4">
                        <Button className='custom-bttn style-2' onClick={() => setShowEditName(false)}>Cancel</Button>
                        <Button type='submit' className='custom-bttn style-3'>Update</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showEditScreenName} onHide={() => setShowEditScreenName(false)} centered>
            <Modal.Header closeButton><Modal.Title>Edit Screen Name</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form onSubmit={updateAccountDetails}>
                    <Form.Group className="mb-4"><Form.Label>Screen Name<span>*</span></Form.Label><Form.Control type="text" placeholder="Ex. johndoe" name='username' value={username} onChange={(e) => setUsername(e.target.value)} /></Form.Group>
                    <div className="d-flex justify-content-center gap-4">
                        <Button className='custom-bttn style-2' onClick={() => setShowEditScreenName(false)}>Cancel</Button>
                        <Button type='submit' className='custom-bttn style-3'>Update</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showEdiProfileImg} onHide={() => setShowEdiProfileImg(false)} centered>
            <Modal.Header closeButton><Modal.Title>Edit Profile Photo</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form onSubmit={updateProfileDetails}>
                    <Form.Group className="mb-4">
                        <Form.Label>Profile Photo<span>*</span></Form.Label>
                        <div className="file-control">
                            <input className="form-control" onChange={(e) =>
                                setProfilePhoto(
                                    e.target.files?.[0] || "No file chosen"
                                )
                            } name="profile_photo" type="file" id="ChooseFile" placeholder="No file chosen*" />
                            <div className='d-flex align-items-center'><Form.Label htmlFor="ChooseFile">Choose File</Form.Label> <span>{profile_photo.name}</span></div>
                        </div>
                    </Form.Group>
                    <div className="d-flex justify-content-center gap-4">
                        <Button className='custom-bttn style-2' onClick={() => setShowEdiProfileImg(false)}>Cancel</Button>
                        <Button type='submit' className='custom-bttn style-3'>Update</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showEditEmail} onHide={() => setShowEditEmail(false)} centered>
            <Modal.Header closeButton><Modal.Title>Edit Email</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form onSubmit={updateAccountDetails}>
                    <Form.Group className="mb-4"><Form.Label>Email<span>*</span></Form.Label><Form.Control type="email" placeholder="Ex. johndoe@gmail.com" name='email' value={email} onChange={(e) => setEmail(e.target.value)} /></Form.Group>
                    <div className="d-flex justify-content-center gap-4">
                        <Button className='custom-bttn style-2' onClick={() => setShowEditEmail(false)}>Cancel</Button>
                        <Button type='submit' className='custom-bttn style-3'>Update</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showChangePassword} onHide={() => setShowChangePassword(false)} centered>
            <Modal.Header closeButton><Modal.Title>Change Password</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form onSubmit={updateAccountDetails}>
                    <Form.Group className="mb-4"><Form.Label>Current Password</Form.Label><Form.Control required type="password" placeholder='Enter password' name='old_password' value={old_password} onChange={(e) => setOldPassword(e.target.value)} /></Form.Group>
                    <Form.Group className="mb-4"><Form.Label>New Password</Form.Label><Form.Control required type="password" placeholder='Enter password' name='password' value={password} onChange={(e) => setPassword(e.target.value)} /></Form.Group>
                    <div className="d-flex justify-content-center gap-4">
                        <Button className='custom-bttn style-2' onClick={() => setShowChangePassword(false)}>Cancel</Button>
                        <Button type='submit' className='custom-bttn style-3'>Update</Button>
                    </div>
                    <p className="text-center text-danger mt-2">
                        {error}
                    </p>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showVerifyEmail} onHide={() => setShowVerifyEmail(false)} centered>
            <Modal.Header closeButton><Modal.Title>Verify Email</Modal.Title></Modal.Header>
            <Modal.Body className="text-center p-4">
                <span className='modal-icon'>
                    <img src={EmailVerify} alt="" />
                </span>
                <h3>Verify your email.</h3>
                <p className="text-muted mt-3">First, let's confirm your email address.</p>
                <div className="d-flex justify-content-center gap-4">
                    <Button className='custom-bttn style-2' onClick={() => setShowVerifyEmail(false)}>Cancel</Button>
                    <Button className='custom-bttn style-3' onClick={() => { setShowVerifyEmail(false); setShowCheckEmail(true); }}>Get Verification Email</Button>
                </div>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showDeactivate} onHide={() => setShowDeactivate(false)} centered>
            <Modal.Header closeButton><Modal.Title>Deactivate Account</Modal.Title></Modal.Header>
            <Modal.Body className="text-center p-4">
                <span className='modal-icon'>
                    <img src={Delete} alt="" />
                </span>
                <h3>Are you sure?</h3>
                <p className="text-muted mt-3">Deactivating your account will temporarily disable your profile and remove your listings from public view.</p>
                <div className="d-flex justify-content-center gap-4">
                    <Button className='custom-bttn style-2' onClick={() => setShowDeactivate(false)}>Cancel</Button>
                    <Button className='custom-bttn style-3' onClick={() => setShowDeactivate(false)}>Confirm</Button>
                </div>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showCheckEmail} onHide={() => setShowCheckEmail(false)} centered>
            <Modal.Header closeButton><Modal.Title>Check Your Email</Modal.Title></Modal.Header>
            <Modal.Body className="text-center p-4">
                <span className='modal-icon'>
                    <img src={EmailConfirm} alt="" />
                </span>
                <h3>Check your email</h3>
                <p className='mb-1'>We sent you an email with a link to confirm your sign in.</p>
                <p>Didn't received email <Link to="/profile" onClick={() => setShowCheckEmail(false)}>Try again</Link></p>
                <div className="d-flex justify-content-center">
                    <Button className='custom-bttn style-3' onClick={() => setShowCheckEmail(false)}>Done</Button>
                </div>
            </Modal.Body>
        </Modal>

        <Modal className='modal-profile' show={showEditDetails} onHide={() => setShowEditDetails(false)} scrollable centered>
            <Modal.Header closeButton><Modal.Title>Edit Details</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form onSubmit={updateProfileDetails}>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-4">
                                <Form.Label>ID / Passport Number</Form.Label>
                                <Form.Control required
                                    type="text"
                                    placeholder="Enter ID/Passport"
                                    value={id_or_passport_number}
                                    onChange={(e) => setIDNumber(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-4">
                        <Form.Label>Physical Address</Form.Label>
                        <Form.Control required type="text" placeholder='Enter Physical Address' value={physical_address} onChange={(e) => setPhysicalAddress(e.target.value)} />
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label>Gender</Form.Label>
                                <Form.Select
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control required
                                    type="tel"
                                    placeholder="Enter Phone Number"
                                    value={phone_number}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label>Date of Birth</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={date_of_birth}
                                    onChange={(e) => setDOB(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-4">
                                <Form.Label>Suburb</Form.Label>
                                <Select
                                    options={options}
                                    value={selectedValues}
                                    onChange={handleChange}
                                    placeholder="Select Suburb..."
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-center gap-4">
                        <Button className='custom-bttn style-2' onClick={() => setShowEditDetails(false)}>Cancel</Button>
                        <Button type='submit' className='custom-bttn style-3'>Update</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    </>
    );
}